// client/src/components/admin/ImpersonationBanner.js
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ApiAdminTools from '../../api/ApiAdminTools'
import useAuth from '../../hooks/useAuth'
import toastr from 'toastr'

function ImpersonationBanner() {
  const [impersonationStatus, setImpersonationStatus] = useState(null)
  const [loading, setLoading] = useState(true)
  const [stopping, setStopping] = useState(false)
  const navigate = useNavigate()
  const { refreshUser } = useAuth()

  useEffect(() => {
    async function checkImpersonationStatus() {
      try {
        const status = await ApiAdminTools.getImpersonateStatus()
        setImpersonationStatus(status)
      } catch (err) {
        console.error('Error checking impersonation status:', err)
      } finally {
        setLoading(false)
      }
    }

    checkImpersonationStatus()
  }, [])

  async function handleStopImpersonate() {
    try {
      setStopping(true)
      await ApiAdminTools.stopImpersonate()
      // Refresh the authentication context to update user state
      await refreshUser()
      // Immediately hide the banner in SPA (no hard reload needed)
      setImpersonationStatus({ isImpersonating: false })
      toastr.success(
        'Returned to your admin account. Redirecting to Admin Users...',
      )
      setTimeout(() => {
        // Use React Router navigation to keep SPA state consistent
        // Cookie/token swap has already occurred (response from stopImpersonate)
        navigate('/admin/users', { replace: true })
      }, 600)
    } catch (err) {
      setStopping(false)
      toastr.error(err.message || 'Failed to stop impersonation')
    }
  }

  if (loading || !impersonationStatus?.isImpersonating) {
    return null
  }

  return (
    <div
      className="alert alert-warning d-flex justify-content-between align-items-center"
      style={{
        margin: 0,
        borderRadius: 0,
        borderLeft: 0,
        borderRight: 0,
        borderTop: 0,
        position: 'sticky',
        top: 0,
        zIndex: 1020,
      }}
    >
      <div>
        <strong>⚠️ Admin Impersonation Mode</strong>
        <div className="small">
          You are viewing the system as User ID:{' '}
          {impersonationStatus.targetUserId}
        </div>
      </div>
      <button
        className="btn btn-sm btn-outline-dark"
        onClick={handleStopImpersonate}
        disabled={stopping}
      >
        {stopping ? 'Returning...' : 'Return to Admin Account'}
      </button>
    </div>
  )
}

export default ImpersonationBanner
